<script>
  import options from './AttachmentsViewer.options'
  export default options
</script>

<template>
  <article class="kb-community-attachments-viewer">
    
    <template v-for="file, index in files" :key="index">

      <div v-if="isDocument(file) || showImagesAsFiles" class="kb-create-post__files-content-wrapper">
        <div class="kb-create-post__files-content-wrapper-left">
          <div v-html="getDocumentIcon(file)"> </div>                        
        </div>
        <div class="kb-create-gallery__files-content-wrapper-right">
          <div class="kb-create-gallery__files-details-wrapper">
            <a class="kb-attachmentsviewer-label" :href="file.url" target="_blank">
              <span class="kb-attachmentsviewer-label--filename">{{ file.filename }}</span>
              <span class="kb-attachmentsviewer-label--icon">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 12 16"><path fill-rule="evenodd" d="M5.5 10.793 3.354 8.646l-.707.707 3 3a.5.5 0 0 0 .707 0l3-3-.707-.707L6.5 10.793V1h-1v9.793zM1 12.5v1a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-1h1v1a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 0 13.5v-1h1z" fill="#3c3c3c"/></svg>
              </span>
            </a>
            <p v-if="getLabel('fileSizeLabel') !== 'fileSizeLabel' && file.filesize" class="kb-attachmentsviewer-label">
              <span class="kb-attachmentsviewer-label--filesize">{{ getLabel('fileSizeLabel') }}: {{ formatFileSize(file.filesize) }}</span>
            </p>
          </div>
        </div>
      </div>

      <figure v-else class="kb-image-module kb-image-module--4-3">
        <div class="kb-image-module__image-container">
          <picture  class="kb-image-module__image">
            <source :srcset="file.url" media="(min-width:1024px)">
            <source :srcset="file.url" media="(min-width: 768px)">
            <source :srcset="file.url" media="(min-width: 376px)">
            <source :srcset="file.url" media="(max-width: 376px)">
            <img :src="file.url" :alt="file.altText">
          </picture>
        </div>
      </figure>

    </template>

  </article>
</template>
